import { Box, Container, ThemeProvider, Typography } from "@mui/material";
import React from "react";
import { xSifterQueryBuilderTheme } from "../../XSifterAppConstants";
import RunningTasksDisplay from "./RunningTasksDisplay";

interface IXSifterAppFooterrProps {

}

const XSifterAppFooter: React.FC<IXSifterAppFooterrProps> = (props: IXSifterAppFooterrProps) => {
    return (
        <ThemeProvider theme={xSifterQueryBuilderTheme}>        
            <Box
                sx={{
                    width: "100%",
                    height: "auto",
                    marginTop: "16px",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    textAlign: "center"
                }}
            >
                <Container maxWidth="lg">
                    <Typography color="textSecondary" variant="subtitle1">
                        (c) {new Date().getFullYear()} XSifter - from <a href="https://texifter.com/" target="_blank" rel="noreferrer">Texifter, Inc.</a>
                    </Typography>
                </Container>
            </Box>
        </ThemeProvider>
    );
}

export default XSifterAppFooter;
